import React from 'react';

import './index.scss';
import { getSystemSettings } from '../../utils/SettingsRetriever';
import PushHistory from '../../utils/PushHistory';
import LocaleAsString from '../../LocaleEngine/LocaleAsString';

export default (props) => {
    const system = getSystemSettings();

    let classNames = "breadcrumb";
    if (props.withTopMargin) classNames += " withTopMargin";
    if (props.withBottomMargin) classNames += " withBottomMargin";

    let additionalStepClassNames = "";
    if (system.theme && system.theme.breadcrumb.withGradient === true) additionalStepClassNames += " gradient";
    if (system.theme && system.theme.breadcrumb.withBorder === true) additionalStepClassNames += " border";

    const checkForLink = (val, idx) => {
        if (typeof val === "string") return null;
        if (val.link && (idx < props.current) ) {
            return PushHistory(val.link);
        }
    }

    return (
        <div className={classNames}>
            {
                props.steps.map((val, idx) => {
                    let stepClass = "step";

                    if((idx + 1) === props.current) stepClass += " active";
                    if((idx + 1) > props.current) stepClass += " notpassed";
                    if((idx + 1) < props.current) stepClass += " passed";

                    if(idx === 0) stepClass += " first";
                    if((idx+1) === props.steps.length) stepClass += ' last'

                    return (
                        <div role="button" onClick={() => checkForLink(val, idx)} key={idx} className={stepClass + (stepClass.indexOf("active") >= 0 ? "" : additionalStepClassNames)}>
                            <div className="stepContent">
                                <div className="stepCount">
                                    <span>{++idx}</span>
                                </div>
                                <span className="stepTitle">{LocaleAsString(val.title || val)}</span>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
